export default {
    en: "English",
    es: "Español",
    pt: "Português"
}